import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const notFoundPageK = {
  goHome: "not_found_page.goHome",
  oopsPageNotFound: "not_found_page.oopsPageNotFound",
};

export const useNotFoundPageT = () => {
  const { t, i18n } = useTranslation();
  
  return useMemo(
    () => ({
      goHome: t(notFoundPageK.goHome),
      oopsPageNotFound: t(notFoundPageK.oopsPageNotFound),
    }),
    [i18n.language]
  );
};